import { Component, OnInit } from "@angular/core";
import { ConvenioService } from "src/app/core/services/convenio.service";
import { PacientesService } from "src/app/core/services/paciente.service";
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";  // ← AGREGAR ESTA LÍNEA
import { AuthenticationService } from "src/app/core/services/auth.service";
import { Router } from "@angular/router";

registerLocaleData(localeEs);

@Component({
  selector: "app-perfil",
  standalone: true,
  imports: [CommonModule, FormsModule],  // ← AGREGAR FormsModule aquí
  templateUrl: "./perfil.component.html",
  styleUrl: "./perfil.component.scss",
})
export class PerfilComponent implements OnInit {
  idPaciente: string = "";
  datosPaciente: any;
  convenios = [];
  mostrarModalConsentimiento: boolean = false;
  consentimientoAceptado: boolean = false;
  mostrarConsentimientoFirmado: boolean = false;

  constructor(
    private __pacientesService: PacientesService,
    private __convenioService: ConvenioService,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.idPaciente = JSON.parse(currentUser).userId;
      this.getPaciente(this.idPaciente);
    }
  }

  // TRAER INFORMACIÓN DEL PACIENTE
  async getPaciente(idPaciente: string) {
    this.__pacientesService.getDocument(idPaciente).then((res: any) => {
      this.datosPaciente = res;
      console.log("DATOS PACIENTE:", this.datosPaciente);
      if (this.datosPaciente.idEmpresa) {
        this.__convenioService
          .getConveniosEmpresaActive(this.datosPaciente.idEmpresa.$id)
          .then((convenios: any) => {
            this.convenios = convenios;
            console.log("DATOS convenios:", this.convenios);
          })
          .catch((error) => {
            console.log(
              "error al consultar informacion de los convenios",
              error
            );
          });
      }
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(["/account/login"]);
  }

  abrirConsentimiento() {
    console.log('Estado del consentimiento:', this.datosPaciente?.consentimiento);
    
    if (this.datosPaciente?.consentimiento === true) {
      console.log('✅ El paciente YA ha firmado el consentimiento informado');
      this.mostrarConsentimientoFirmado = true;
    } else {
      console.log('❌ El paciente NO ha firmado el consentimiento informado');
      this.mostrarModalConsentimiento = true;
    }
  }

  cerrarModalConsentimiento() {
    this.mostrarModalConsentimiento = false;
    this.consentimientoAceptado = false;
  }

  cerrarModalFirmado() {
    this.mostrarConsentimientoFirmado = false;
  }

  async firmarConsentimiento() {
    if (!this.consentimientoAceptado) {
      alert('Debes aceptar los términos del consentimiento informado para continuar');
      return;
    }
  
    try {
      // Crear el objeto de actualización con el tipo correcto
      const datosActualizacion = {
        consentimiento: true,
        fechaConsentimiento: new Date().toISOString()
      };
  
      // Actualizar el documento en Appwrite
      await this.__pacientesService.updateDocument(
        this.idPaciente,
        datosActualizacion as any
      );
  
      // Actualizar los datos locales
      this.datosPaciente.consentimiento = true;
      this.datosPaciente.fechaConsentimiento = new Date().toISOString();
  
      // Cerrar modal y mostrar éxito
      this.cerrarModalConsentimiento();
      
      alert('¡Consentimiento firmado exitosamente!');
      
      console.log('✅ Consentimiento firmado exitosamente');
  
    } catch (error) {
      console.error('Error al firmar el consentimiento:', error);
      alert('Error: No se pudo registrar el consentimiento. Por favor intenta nuevamente.');
    }
  }

  cerrarCuenta() {
    if (confirm("¿Estás seguro de que deseas eliminar tu cuenta? Esta acción no se puede deshacer.")) {
      // Aquí va la lógica para eliminar la cuenta 
      console.log("Cuenta eliminada");
    }
  }
}